import { render, staticRenderFns } from "./PageAccessDenied.vue?vue&type=template&id=79d58c09"
import script from "./PageAccessDenied.vue?vue&type=script&lang=js"
export * from "./PageAccessDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports